module.exports = __webpack_public_path__ + "img/bg.3d762564.svg";